/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import OrgAppAuthProviderForm from './OrgAppAuthProviderForm';
import { createOrgApplicationAuthProvider } from '../../../../../../../../services/organization/OrgAppAuthProvider';
import { getAllOrgApplicationAuthProviders } from '../../../../../../../../store/reducers/organization/orgAppAuthProvider/orgAppAuthProviderAction';

const OrgAppAuthProviderCreation = ({ handleClose }) => {
    const { orgid } = useParams()
    const dispatch = useDispatch()
    const handleSubmit = async ({ organizationID, authProviderID, organizationApplicationID, assertionConsumerServiceURL }, { setSubmitting }) => {
        try {
            setSubmitting(true)
            console.log({ organizationID, authProviderID, organizationApplicationID, assertionConsumerServiceURL });
            await createOrgApplicationAuthProvider({ organizationID, authProviderID, organizationApplicationID, assertionConsumerServiceURL });
            toast.success('Organization Application Identity Provider was registred successfully');
            handleClose();
            await dispatch(getAllOrgApplicationAuthProviders()).unwrap();
            setSubmitting(false);
        } catch (error) {

            toast.error(error?.response?.data?.error?.message);
            setSubmitting(false);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Application Identity Provider Registration</Typography>
            <Formik
                initialValues={{
                    organizationID: orgid ? orgid : '',
                    organizationApplicationID: '',
                    authProviderID: '',
                    assertionConsumerServiceURL: ''
                }}
                validationSchema={Yup.object().shape({
                    organizationID: Yup.string().required('Organization is required.'),
                    organizationApplicationID: Yup.string().required('Organization Application is required.'),
                    authProviderID: Yup.string().required('Identity Provider is required.'),
                    assertionConsumerServiceURL: Yup.string()
                        .url('Enter a valid URL'),
                })}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <OrgAppAuthProviderForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


export default OrgAppAuthProviderCreation;
